
import React from 'react';
import styles from "./Button.module.scss";
import clsx from "clsx";

interface ButtonProps {
  /**
   * Is this the principal call to action on the page?
   */
  primary?: boolean;
  /**
   * What background color to use
   */
  backgroundColor?: string;
  /**
   * How large should the button be?
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * Button contents
   */
  label: string;
  color: string;
  variant?: 'filled' | 'outlined';
  alt?: string;
  type?: 'button' | 'submit' | 'reset';
  /**
   * Optional click handler
   */
  onClick?: () => void;
  className: any;
}

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  primary = false,
  size = 'medium',
  variant = 'filled',
  color = 'red',
  type = 'button',
  backgroundColor,
  label,
  className,
  alt = '',
  ...props
}: ButtonProps) => {
  const classNames = clsx(
    styles.btn,
    styles[variant],
    styles[size],
    styles[color],
    className,
    styles.a
  );
  return (
    <button
      type="button"
      className={classNames}
      aria-label={alt}
      {...props}
    >
      {label}
    </button>
  );
};
